/* ============================================================
   HIT: o fim da página do produto da B (PLANO, Tarefa 20, passos 2 e 3): "Complete o look" / "Complete o kit", "Outros {família}" e o
   trilho da categoria. Portado de projetos/design-propostas/direcao-b/index.html (blocoLook e paginaProduto, o bloco `irm`).
   O servidor (snippets/mais-produto) reserva três <section hidden data-mais="look|familia|categoria"> vazias; este arquivo escolhe
   os itens na vitrine ao vivo (HitDados.vitrine(), do resumo do catálogo com estoque, D18) e desenha o bloco dentro de cada uma.

   REGRA 4 DO PLANO: número na tela vem do dado, nunca digitado; bloco cujo dado falhou SOME, não mostra zero.
     - o resumo falhou (HitDados rejeita), falta script, texto ou o produto da página: as três seções ficam escondidas e vazias;
     - "Complete o look/kit": 3 ou mais itens com estoque (D19, cfg.minComplemento), senão nem o título (HitVitrine.complementos);
     - "Outros {família}": só nas marcas com casa e com outra linha da família com estoque; sem a casa configurada o link sai, o trilho fica;
     - categoria: até cfg.limites.trilhoCategoria unidades da mesma subcategoria, sem a linha do próprio produto; "Ver tudo" só com URL.
   Sem JS as três seções ficam escondidas: sem dado não há número. O aria-busy do servidor sai de cada seção quando o resultado dela (bloco,
   nada a mostrar ou falha) está decidido: é o sinal de que a página assentou.

   LINKS. Os do "Complete o look" e do "Complete o kit" usam os nomes de filtro do HitConfig.param (ajustes param_categoria e param_marca):
   /collections/all?<categoria>=Roupas&<marca>=<vendor>. Nunca levam filter.v.availability (D5, 19/10/2026: o esgotado aparece nos destinos,
   depois dos disponíveis); os itens do trilho, esses sim, são só os com estoque (V.estoque). Sem o nome de um dos parâmetros, ou com 0 itens
   no destino, o link sai (PENDENTE T5: até o Search & Discovery ter os filtros, o destino não filtra). "Ver na casa" vai para
   /collections/<casa>#fam-<slug da família> e "Ver tudo" para a coleção real da categoria (snippets/pdp-destinos), a mesma da migalha.

   TEXTOS. Da ilha <script type="application/json" id="hit-produto-mais"> (snippets/scripts-produto): { produto, casa, verTudo, todos, textos }.
   Texto puro, {n}, {marca} e {familia} no lugar das variáveis. Este arquivo não tem texto fixo de tela.

   LÓGICA PURA (provada em Node por verificacao/produto-mais.test.cjs):
     HitProdutoMais.look(V, p, param, todos)       null | { tipo, itens, n, marca, mesmaMarca, nLink, href }
     HitProdutoMais.familia(V, p, casa, slug)      null | { familia, unidades, marca, href }
     HitProdutoMais.categoria(V, p, verTudo)       null | { titulo, unidades, href }
     HitProdutoMais.hrefFiltro(todos, param, f)    o link de filtro por categoria e marca, ou null
     HitProdutoMais.texto(t, n, vars)              t texto ou { one, other }; preenche {n} e as variáveis
   Nada aqui altera as entradas.
   ============================================================ */
(function () {
  'use strict';

  const PLURAL = new Intl.PluralRules('pt-BR');
  const temTexto = (s) => typeof s === 'string' && s.trim() !== '';
  const tem = (o, k) => Object.prototype.hasOwnProperty.call(o, k);
  const CAT_ROUPAS = 'Roupas', CAT_ACESSORIOS = 'Acessórios'; // os nomes de hit.categoria que a B usa nos links do look e do kit

  function texto(t, n, vars) {
    const modelo = t && typeof t === 'object' ? (PLURAL.select(n) === 'one' && t.one !== undefined ? t.one : t.other) : t;
    const v = Object.assign({}, vars, { n });
    return String(modelo).replace(/\{(\w+)\}/g, (m, k) => (tem(v, k) && v[k] != null ? String(v[k]) : m));
  }

  /* <todos>?<categoria>=<cat>[&<marca>=<vendor>], sem filtro de estoque (D5); null sem a coleção ou sem o nome de um dos parâmetros */
  function hrefFiltro(todos, param, f) {
    if (!temTexto(todos) || !param || !temTexto(param.categoria) || (f.marca != null && !temTexto(param.marca))) return null;
    const par = (k, v) => encodeURIComponent(k.trim()) + '=' + encodeURIComponent(v);
    const q = [par(param.categoria, f.categoria)].concat(f.marca != null ? [par(param.marca, f.marca)] : []);
    return todos + '?' + q.join('&');
  }

  /* B: blocoLook. O link (roupas da marca, ou acessórios) sai com 0 itens no destino */
  function look(V, p, param, todos) {
    const c = V.complementos(p);
    if (!c) return null;
    const kit = c.tipo === 'kit', marca = V.marcaCurta(p.marca);
    const nLink = V.estoque.filter((x) => (kit ? x.categoria === CAT_ACESSORIOS : x.categoria === CAT_ROUPAS && x.marca === marca)).length;
    const href = nLink > 0 ? hrefFiltro(todos, param, kit ? { categoria: CAT_ACESSORIOS } : { categoria: CAT_ROUPAS, marca }) : null;
    return Object.freeze({ tipo: c.tipo, itens: c.itens, n: c.itens.length, marca, mesmaMarca: !kit && c.itens.every((x) => x.marca === marca), nLink, href });
  }

  /* B: "Outros {família}" (o bloco irm). `casa`: o caminho da coleção da casa (/collections/on-running) ou vazio */
  function familia(V, p, casa, slug) {
    const unidades = V.outrosDaFamilia(p);
    if (!unidades.length) return null;
    const fam = unidades[0].linha.familia; // todas as linhas devolvidas são da mesma família
    return Object.freeze({ familia: fam, unidades, marca: V.marcaCurta(p.marca), href: temTexto(casa) ? casa + '#fam-' + slug(fam) : null });
  }

  /* B: o trilho da categoria. O título é a subcategoria (ou a categoria, sem ela) */
  function categoria(V, p, verTudo) {
    const unidades = V.trilhoCategoria(p);
    if (!unidades.length) return null;
    return Object.freeze({ titulo: p.subcategoria || p.categoria, unidades, href: temTexto(verTudo) ? verTudo : null });
  }

  const HitProdutoMais = Object.freeze({ look, familia, categoria, hrefFiltro, texto });
  if (typeof module !== 'undefined') module.exports = HitProdutoMais;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.HitProdutoMais = HitProdutoMais;

  /* ============================== na página ============================== */
  const $$ = (s, r) => Array.prototype.slice.call(r.querySelectorAll(s));
  const reTrilho = (el) => { if (window.HitTrilhos && el) window.HitTrilhos.atualizaTrilho(el); };

  function lerIlha() {
    const ilha = document.getElementById('hit-produto-mais');
    const d = ilha ? JSON.parse(ilha.textContent) : null;
    const t = d && d.textos;
    const ok = d && d.produto && temTexto(d.produto.handle) && temTexto(d.produto.marca) && t && t.look && t.kit && t.familia && t.categoria
      && temTexto(t.look.titulo) && temTexto(t.look.verRoupas)
      && temTexto(t.kit.titulo) && temTexto(t.kit.verAcessorios)
      && temTexto(t.familia.titulo) && temTexto(t.familia.verNaCasa) && temTexto(t.categoria.verTudo);
    if (!ok) throw new Error('HitProdutoMais: dados ou textos ausentes ou incompletos (#hit-produto-mais)');
    return d;
  }

  const link = (E, href, t) => (href ? `<a class="lk" href="${E(href)}">${E(t)}</a>` : '');
  const cabeca = (E, titulo, id, direita) => `<div class="sec-cab"><h2 class="pdp-h2" id="${id}">${E(titulo)}</h2><div class="sc-dir">${direita}</div></div>`;

  const DESENHA = {
    look(raiz, X) {
      const d = look(X.V, X.D.produto, X.param, X.D.todos);
      if (!d) return false;
      const T = X.D.textos[d.tipo], kit = d.tipo === 'kit', E = X.P.E;
      const ver = d.href ? texto(kit ? T.verAcessorios : T.verRoupas, d.nLink, { marca: X.nome(d.marca) }) : '';
      raiz.innerHTML = `<div class="sec-cab"><h2 class="pdp-h2" id="look-t">${E(T.titulo)}</h2><div class="sc-dir">${link(E, d.href, ver)}${X.P.setasHtml('tri-look')}</div></div>`
        + X.P.trilhoHtml({ id: 'look', rotulo: T.titulo, itens: d.itens.map((x) => X.P.cardSolto(x, { genero: true })).join('') });
      raiz.setAttribute('aria-labelledby', 'look-t');
      return true;
    },
    familia(raiz, X) {
      const d = familia(X.V, X.D.produto, X.D.casa, X.slug);
      if (!d) return false;
      const T = X.D.textos.familia, E = X.P.E, titulo = texto(T.titulo, d.unidades.length, { familia: d.familia });
      raiz.innerHTML = cabeca(E, titulo, 'irmaos-t', link(E, d.href, texto(T.verNaCasa, d.unidades.length, { marca: X.nome(d.marca) })) + X.P.setasHtml('tri-irmaos'))
        + X.P.trilhoHtml({ id: 'irmaos', rotulo: titulo, itens: d.unidades.map((u) => X.P.cardUnidade(u, {}, { semFaixa: true })).join('') });
      raiz.setAttribute('aria-labelledby', 'irmaos-t');
      return true;
    },
    categoria(raiz, X) {
      const d = categoria(X.V, X.D.produto, X.D.verTudo);
      if (!d) return false;
      const T = X.D.textos.categoria, E = X.P.E;
      // raquete: "Outras raquetes para conhecer" (DIRECAO-CARD-PDP.md 8.5, item 4); o resto mantém o nome real da subcategoria
      const titulo = temTexto(T.titulo) ? T.titulo : X.P.subcategoriaNome(X.D.produto.categoria, d.titulo);
      raiz.innerHTML = cabeca(E, titulo, 'categoria-t', link(E, d.href, T.verTudo) + X.P.setasHtml('tri-categoria'))
        + X.P.trilhoHtml({ id: 'categoria', rotulo: titulo, itens: d.unidades.map((u) => X.P.cardUnidade(u, {}, { semFaixa: true })).join('') });
      raiz.setAttribute('aria-labelledby', 'categoria-t');
      return true;
    },
  };

  function somem(raizes, motivo) {
    raizes.forEach((r) => { r.hidden = true; r.innerHTML = ''; r.removeAttribute('aria-busy'); });
    console.warn('HitProdutoMais: os blocos do fim da página que dependem do catálogo saíram:', motivo && motivo.message ? motivo.message : motivo);
  }

  /* desenha os blocos dentro de `onde` (o documento, ou a seção que o editor de temas acabou de redesenhar) */
  function inicia(onde) {
    const raizes = $$('[data-mais]', onde).filter((r) => tem(DESENHA, r.getAttribute('data-mais')));
    if (!raizes.length) return;
    let X;
    try {
      const C = window.HitConfig;
      if (!window.HitDados || !window.HitPecas || !window.HitVitrine || !C) throw new Error('faltam o hit-dados.js, o hit-vitrine.js, o hit-pecas.js ou o HitConfig');
      X = { D: lerIlha(), P: window.HitPecas.criar({ parcela: C.parcela, textos: C.textos }), param: C.param || null, slug: window.HitVitrine.slug, nome: window.HitVitrine.nomeDaMarca };
    } catch (e) { somem(raizes, e); return; }
    window.HitDados.vitrine().then((V) => {
      raizes.forEach((r) => {
        try {
          if (!DESENHA[r.getAttribute('data-mais')](r, Object.assign({ V }, X))) { r.hidden = true; r.innerHTML = ''; r.removeAttribute('aria-busy'); return; } // sem dado: some em silêncio
          r.hidden = false;
          r.removeAttribute('aria-busy');
          reTrilho(r.querySelector('[data-rol]'));
        } catch (e) { somem([r], e); }
      });
    }, (e) => somem(raizes, e));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => inicia(document));
  else inicia(document);
  document.addEventListener('shopify:section:load', (e) => inicia(e.target));
})();
